import { useContext } from "react";

import debug from "debug";

import { SticksDataContext } from "./SticksDataProvider";

const log = debug("desjti:sticksDataProvider:useSticksData");

export const useSticksDataContext = () => {
  const context = useContext(SticksDataContext);

  if (context === undefined) {
    log("useSticksData hook used outside of SticksDataProvider");
    throw new Error("useSticksData hook used outside of SticksDataProvider");
  }

  return context;
};
